var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2C14.8125 2.02083 14.9792 2.1875 15 2.5V7.5C14.9792 7.8125 14.8125 7.97917 14.5 8H2.5C2.1875 7.97917 2.02083 7.8125 2 7.5V2.5C2.02083 2.1875 2.1875 2.02083 2.5 2H14.5ZM2.5 0C1.79167 0.0208333 1.19792 0.260417 0.71875 0.71875C0.260417 1.19792 0.0208333 1.79167 0 2.5V7.5C0.0208333 8.20833 0.260417 8.80208 0.71875 9.28125C1.19792 9.73958 1.79167 9.97917 2.5 10H14.5C15.2083 9.97917 15.8021 9.73958 16.2812 9.28125C16.7396 8.80208 16.9792 8.20833 17 7.5V7C17.2917 7 17.5312 6.90625 17.7188 6.71875C17.9062 6.53125 18 6.29167 18 6V4C18 3.70833 17.9062 3.46875 17.7188 3.28125C17.5312 3.09375 17.2917 3 17 3V2.5C16.9792 1.79167 16.7396 1.19792 16.2812 0.71875C15.8021 0.260417 15.2083 0.0208333 14.5 0H2.5ZM9 3H3V7H9V3Z",
    fill: "#45474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.0b3f1d141400f1e38df6d0d5fe608dce.svg";
export { ForwardRef as ReactComponent };